/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import * as Yup from 'yup';

import { getFormLocale } from '../../../modules/form/const/formLocalization';
import { ECalendarPeriod } from '../../../modules/internationalization/types/common/calendar';
import { ICorporateFormTranslation } from '../../../modules/internationalization/types/corporate';
import { IOptionItemProps } from '../Select/Select';
import { EReportScheduleField } from './types';

export const hourOptions: IOptionItemProps[] = Array.from(Array(24)).map((_, i: number) => ({
    value: i, label: `0${i}`.slice(-2),
}));

export const minuteOptions: IOptionItemProps[] = Array.from(Array(12)).map((_, i: number) => ({
    value: i * 5, label: `0${i * 5}`.slice(-2),
}));

export const ReportScheduleValidationSchema = (translation: ICorporateFormTranslation['validation']) => {
    Yup.setLocale(getFormLocale(translation));

    return Yup.object().shape({
        [EReportScheduleField.Description]: Yup.string().nullable(),
        [EReportScheduleField.Month]: Yup.number().when(EReportScheduleField.Period, {
            is: (period: IOptionItemProps) => period.value === ECalendarPeriod.M,
            then: Yup.number().min(1).max(31).required(),
            otherwise: Yup.number().nullable(),
        }),
        [EReportScheduleField.Period]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required(),
        }),
        [EReportScheduleField.TimeHour]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required(),
        }),
        [EReportScheduleField.TimeMinute]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required(),
        }),
        [EReportScheduleField.Week]: Yup.object().when(EReportScheduleField.Period, {
            is: (period: IOptionItemProps) => period.value === ECalendarPeriod.W,
            then: Yup.object().shape({
                value: Yup.string().required(),
                label: Yup.string().required(),
            }),
            otherwise: Yup.object().nullable(),
        }),
    });
}
